module.exports = __webpack_public_path__ + "static/img/banner-aug-17.c4b1e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-aug-17.png
// module id = 4IFy
// module chunks = 1